/**
 * 郵便番号から住所情報を返却する
 */

var Address = Address || {};

Address.getAddressForZipcode = function(zipcode) {
	var defer = $.Deferred();
	$.ajax({
		url: '/service/address-for-zipcode.json',
		method: 'GET',
		data: {
			zipcode: zipcode
		},
		success: defer.resolve,
		error: defer.reject
	});
	return defer.promise();
};

Address.getDeliveryBlackList = function(cityCode) {
	var defer = $.Deferred();
	$.ajax({
		url: '/service/delivery-area-blacklist.json',
		method: 'GET',
		data: {
			cityCode: cityCode
		},
		success: defer.resolve,
		error: defer.reject
	});
	return defer.promise();
};
